import { Fragment } from 'react'
import { Link, Stack, Box, Grid } from '@mui/material';
import importedStyles from '../Utilities/styles'
import DashboardCard from '../Utilities/DashboardCard';
import DataTeaser, { formatEntry } from '../Utilities/DataTeaser';
// import Badge from '../Utilities/Badge';
import useImpactMetrics from "../Utilities/hooks/useImpactMetrics";
import {formatDuration} from "_helpers";
import moment from "moment";

const InfoModalContent = () => (
	<Box component={'dl'} sx={importedStyles.definitionList}>
		<Fragment>
			<Box component={'dt'} sx={importedStyles.definitionTitle}>Conversations resolved</Box>
			<Box component={'dd'} sx={importedStyles.definitionText}>The number of tickets solved by Remarkable AI during the time frame selected.</Box>
		</Fragment>
	</Box>
)

export default function ImpactSection({ startDate, endDate }) {
	const { data, loadingImpactMetrics } = useImpactMetrics(startDate, endDate);
	const duration = data ? formatDuration(data.estimatedTimeSavedPerCustomerInMin) : null;

	return (
		<DashboardCard
			isLoading={loadingImpactMetrics}
			headerTitle='Impact metrics'
			infoModalTitle='Impact metrics calculations'
			infoModalChildren={<InfoModalContent />}>

			<Grid container columns={4} spacing={3} sx={styles.root}>
				<Grid item xs={4} md={1}>
					<DataTeaser
						label={'Time saved'}
						entry={{ value: duration, formatStyle: null }}
						descriptionChildren={<>
							<Box>On average, it takes about 3 minutes to resolve a ticket.</Box>
						</>}
					/>
				</Grid>

				{/*@TODO: Enable section when feature is ready*/}
				{/*<Grid item xs={4} md={1}>*/}
				{/*	<DataTeaser*/}
				{/*		label={'Estimiated revenue generated'}*/}
				{/*		entry={{ value: data ? data.estimatedRevenueGeneratedUSD : null, formatStyle: 'currency' }}*/}
				{/*		descriptionChildren={<>*/}
				{/*			<Box>{*/}
				{/*				data */}
				{/*					? `Presale question conversion rate lead to a*/}
				{/*					${formatEntry({ value: data.estimatedRevenueGeneratedPercent, formatStyle: 'percent' })}*/}
				{/*					increase in revenue generated.` : ``*/}
				{/*				}*/}
				{/*			</Box>*/}
				{/*		</>}*/}
				{/*	/>*/}
				{/*</Grid>*/}

				<Grid item xs={4} md={1}>
					<DataTeaser
						label={'Conversations Resolved'}
						entry={{ value: data ? data.ticketsSolvedAmount : null, formatStyle: 'number' }}
						descriptionChildren={<>
							<Stack spacing={0.5}>
								<Stack direction={'row'} flexWrap={'wrap'}>
									<Box sx={{ fontFamily: 'FustatSemiBold' }}>Current month:&nbsp;</Box>
									<Box>{data ? (
										<>
											<Box>
												{formatEntry({ value: data.ticketsSolvedMonthToDateAmount, formatStyle: 'number' })} tickets
												{/*@TODO: Enable section when feature is ready*/}
												{/*({formatEntry({ value: data.ticketsRemainingMonthToDateAmount, formatStyle: 'number' })} remaining)*/}
											</Box>
										</>
									) : <>&ndash;</>}</Box>
								</Stack>

								{/*@TODO: Enable section when feature is ready*/}
								{/*<Stack direction={'row'} spacing={0.5}>*/}
								{/*	<Badge type={'secondary'}>*/}
								{/*	{ data ? (*/}
								{/*		formatEntry({ value: data.ticketsSolvedMonthToDateCompareLastMonthPercent, formatStyle: 'percent' })*/}
								{/*	) : <>&ndash;</>}*/}
								{/*	</Badge>*/}
								{/*	<Box>since last month</Box>*/}
								{/*</Stack>*/}

								<Stack direction={'row'}>
									<Box sx={{ fontFamily: 'FustatSemiBold' }}>All-time total:&nbsp;</Box>
									<Box>{data ? (
										<>
											{formatEntry({ value: data.ticketsSolvedAllTime, formatStyle: 'number' })} tickets
										</>
									) : <>&ndash;</>}</Box>
								</Stack>

								<Box>
									Email{' '}
									<Link
										sx={importedStyles.textLink}
										underline='none'
										href={'mailto:support@beremarkable.ai'}>
										support@beremarkable.ai
									</Link>
									{' '}to add more tickets
								</Box>
							</Stack>
						</>}
					/>
				</Grid>

				<Grid item xs={4} md={1}>
					<DataTeaser
						label={'Tickets Hidden'}
						entry={{ value: data ? data.ticketsHiddenAmount : null, formatStyle: 'number' }}
					/>
				</Grid>
			</Grid>
		</DashboardCard>
	)
}

const styles = {
	root: {
		py: { xs: 2, md: 4 },
	}
}